var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Unauthorized")]),_c('hr'),_c('p',[_vm._v("\n    You do not have access to this system. If this is in error, please email\n    accounts@arm.gov to get this corrected.\n  ")])])
}]

export { render, staticRenderFns }